import { useContext, useState, useEffect, useCallback } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export const useInternalNavigationPreventOnChange = (changesMade) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [nextNavigation, setNextNavigation] = useState(null);
  const navigator = useContext(UNSAFE_NavigationContext).navigator;

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    if (nextNavigation) {
      nextNavigation?.retry();
    }
  }, [nextNavigation]);

  const cancelNavigation = useCallback(() => {
    setNextNavigation(null);
    setShowPrompt(false);
  }, []);

  useEffect(() => {
    if (!changesMade) return;

    const push = navigator.push;

    navigator.push = (...args) => {
      setShowPrompt(true);
      setNextNavigation({ retry: () => push(...args) });
    };

    return () => {
      setNextNavigation(null);
      navigator.push = push;
    };
  }, [navigator, changesMade]);

  return { showPrompt, confirmNavigation, cancelNavigation };
};
